var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "item-row px-3 py-2 d-flex align-items-center justify-content-between w-100",
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _vm.pinned
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: `Text to Image always runs first and can't be reordered`,
                    },
                    expression:
                      "{ content: `Text to Image always runs first and can't be reordered` }",
                  },
                ],
                staticClass: "handle-icon mr-2",
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "lock"] } })],
              1
            )
          : _c(
              "span",
              { staticClass: "handle-icon mr-2" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "grip-dots-vertical"] },
                }),
              ],
              1
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("font-awesome-icon", {
              staticClass: "counter mr-2",
              attrs: { icon: ["fa-solid", _setup.icon || ""] },
            }),
            _vm._v(" "),
            _c("div", [
              _c("span", [
                _vm._v(_vm._s(_setup.effectInfo?.label || "Unknown Effect")),
              ]),
              _vm._v(" "),
              _setup.effectInfo?.tags.length
                ? _c("span", { staticClass: "text-muted" }, [
                    _vm._v("(" + _vm._s(_setup.effectInfo?.tags[0]) + ")"),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end" },
        [
          _setup.isEditable
            ? _c(_setup.CButton, {
                attrs: {
                  size: "icon",
                  icon: ["far", "pen"],
                  disabled: _vm.readonly,
                },
                on: { click: _setup.handleOpen },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(_setup.CButton, {
            attrs: {
              size: "icon",
              icon: ["far", "trash-can"],
              disabled: _vm.readonly,
            },
            on: { click: _setup.handleRemove },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.ImageEffectsPropertiesModalsEdit, {
        attrs: { "is-open": _setup.isOpen, item: _vm.item },
        on: { update: _setup.handleUpdate, close: _setup.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }